export default theme => ({
  topbar: {
    position: 'fixed',
    width: '100%',
    top: 0,
    left: 0,
    right: 'auto',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  topbarShift: {
    marginLeft: '271px',
    width: 'calc(-271px + 100vw)'
  },
  drawerPaper: {
    zIndex: 1200,
    width: '271px'
  },
  sidebar: {
    // width: '270px'
    width: '100%',
  },
  content: {
    // marginTop: '64px',
    minHeight: 'calc(100vh - 38px)',
    paddingTop: '64px',
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  contentShift: {
    marginLeft: '270px',
  },
  progressbar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  footerLinks: {
    textAlign: 'center',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1),
    '& a, & span': {
      margin: theme.spacing(0, 1),
      color: theme.palette.text.secondary,
      textDecoration: 'none',
      fontSize: '12px',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '& span': {
      '&:hover': {
        textDecoration: 'none !important',
      },
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0px !important',
      '& a, & span': {
        width: '100%',
        display: 'block',
      },
    },
  },
  contentShiftFooterLinks: {
    paddingLeft: '270px',
  },
});
